import api from "../http-request";
// [GET] method
export const getListRoleBannerApi = async (params) =>
  api.get(`/api/roll-banner/list`, { params });
export const getDetailRoleBannerApi = async (id) =>
  api.get(`/api/roll-banner/detail/${id}`);
// [POST] method
export const createRollBanner = async (data) =>
  api.post(`/api/admin/roll-banner/create`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
export const updateRollBanner = async (id, data) =>
  api.post(`api/admin/roll-banner/update/${id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
// [DELETE] method
export const deleteRoleBannerApi = async (id) =>
  api.delete(`/api/admin/roll-banner/delete/${id}`);
